import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export const GET_EVENT_SUBSCRIPTION_CHECKOUT_CART = 'get-event-subscription-checkout-cart';

export type EventSubscriptionCheckoutCartLine = {
  subscriptionProductKey: string;
  tier: string;
  billingPeriod?: string;
  additionalQuotaUnits?: { quotaKey: string; quantity: number }[];
  parentSubscriptionInstanceId?: string;
  scopeType?: string;
  scopeId?: string;
};

export type EventSubscriptionCheckoutCartResponse = {
  cart: {
    lines?: EventSubscriptionCheckoutCartLine[];
    updatedAt?: string;
  } | null;
  totals: { totalEur: number; vatRate: number; lineDeltas: { key: string; amountEur: number }[] };
  /** Owning organization for billing/VAT — never the UI "active" org. */
  billingOrganizationId: string | null;
};

export function useEventSubscriptionCheckoutCartQuery(eventId: string | undefined, enabled = true) {
  const { getToken } = useAuth();
  return useQuery({
    enabled: Boolean(eventId) && enabled,
    queryKey: [GET_EVENT_SUBSCRIPTION_CHECKOUT_CART, eventId],
    queryFn: async (): Promise<EventSubscriptionCheckoutCartResponse> => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/event/${eventId}/subscription-checkout-cart`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' });
    },
  });
}
